<div class="set-game-scoreboard-header" *ngIf="!hasExtended">
    <div class="cell points" *ngIf="points">{{ sitecore.eventGrid.Scoreboard_P }}</div>
    <div class="cell games" *ngIf="games && points">{{ sitecore.eventGrid.Scoreboard_G }}</div>
    <div class="cell sets" *ngIf="sets">{{ sitecore.eventGrid.ScoreboardSets }}</div>
</div>
